"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CRM = void 0;

var _expenseTracking = require("./expenseTracking");

var _teamActivity = require("./teamActivity");

var _toDos = require("./toDos");

var _navigation = require("./navigation");

var CRM = {
  EXPENSE_TRACKING: _expenseTracking.EXPENSE_TRACKING,
  TEAM_ACTIVITY: _teamActivity.TEAM_ACTIVITY,
  TO_DOS: _toDos.TO_DOS,
  NAVIGATION: _navigation.NAVIGATION
};
exports.CRM = CRM;